import { render, staticRenderFns } from "./RecipeConsumptionReport.vue?vue&type=template&id=5ca50f1e&scoped=true"
import script from "./RecipeConsumptionReport.vue?vue&type=script&lang=js"
export * from "./RecipeConsumptionReport.vue?vue&type=script&lang=js"
import style0 from "./RecipeConsumptionReport.vue?vue&type=style&index=0&id=5ca50f1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca50f1e",
  null
  
)

export default component.exports